<template>
  <div>
    <input class="form-control form-control-sm" type="time" v-model="text" />
  </div>
</template>

<script>
const year = "1970-01-01 ";
export default {
  name: "mes-time-picker",
  props: {
    value: {
      type: String,
      default: year + "00:00"
    }
  },
  computed: {
    text: {
      get() {
        if (!this.value) {
          return "";
        }
        return this.value.slice(year.length, year.length + 5);
      },
      set(v) {
        console.log({ v });
        // this.value = v;
        this.$emit("input", year + v + ":00");
      }
    }
  }
};
</script>